import { __read, __awaiter, __generator } from 'tslib';
import * as React from 'react';

function useEffectAsync(func, deps, initialData) {
    var _this = this;
    var _a = __read(React.useState(initialData), 2), data = _a[0], setData = _a[1];
    var _b = __read(React.useState(false), 2), isLoading = _b[0], setIsLoading = _b[1];
    var _c = __read(React.useState(), 2), error = _c[0], setError = _c[1];
    var lastFetchTime = React.useRef(0);
    var fetch = React.useCallback(function (currentTime) { return __awaiter(_this, void 0, void 0, function () {
        var mostRecentCall, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setError(undefined);
                    setIsLoading(true);
                    mostRecentCall = currentTime === lastFetchTime.current;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, func()];
                case 2:
                    result = _a.sent();
                    if (mostRecentCall) {
                        setIsLoading(false);
                        setData(result);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setIsLoading(false);
                    if (mostRecentCall) {
                        setData(initialData);
                        setError(error_1);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [func]);
    var fetchData = function () {
        // get current time
        var lastFetchDispatched = new Date().getTime();
        // adding time to lastFetchTime, which will always filled with the most recent time
        lastFetchTime.current = lastFetchDispatched;
        // sending current date to fetch, to know when this fetch was called
        fetch(lastFetchDispatched);
    };
    // if multiple async calls are triggered, we only want to return the most-recent result
    React.useEffect(function () {
        fetchData();
        // this useEffect cleanup func will cancel previous useEffect calls and prevent them from being saved with setData
        // see: https://overreacted.io/a-complete-guide-to-useeffect/#speaking-of-race-conditions
        return function () {
            lastFetchTime.current = 0;
        };
    }, deps);
    return { data: data, error: error, fetchData: fetchData, isLoading: isLoading };
}

export { useEffectAsync };
//# sourceMappingURL=useEffectAsync.esm.js.map
